import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as StatusList from 'types/_general/Store/StatusList';

const rb = new ReducerBuilder<StatusList.Type>();
export const createStatusListLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'StatusList/LoadedFromBackend'
);

export const statusListReducer = rb.createReducer();
